/**
 * Generic scroll-in-view reveal: any element marked [data-ryvex-reveal] starts
 * hidden (styled per-section in each section's own stylesheet) and gets
 * .is-revealed added the first time it crosses into the viewport. Mirrors the
 * reference's framer-motion `whileInView` + `viewport={{ once: true }}` behavior.
 */
const revealObserver = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;

      entry.target.classList.add('is-revealed');
      revealObserver.unobserve(entry.target);
    }
  },
  { threshold: 0.15, rootMargin: '0px 0px -80px 0px' }
);

document.querySelectorAll('[data-ryvex-reveal]').forEach((element) => {
  revealObserver.observe(element);
});
